/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

import axios from "axios";
import VueAxios from "./utilities/VueAxios";
import SVGIcon from "./components/SVGIcon";
import Vue from "vue";
import Toasted from "vue-toasted";
import store from "./store";
import { getToken, fillHeaderAuth } from "./utilities/helpers";
import jwtDecode from "jwt-decode";
import JsonExcel from "vue-json-excel";

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
Vue.use(VueAxios, axios);
Vue.http.defaults.baseURL = process.env.VUE_APP_BASE_URI;

Vue.http.interceptors.request.use(config => {
  if (config.headers.common.Authorization) {
    const bearer = config.headers.common.Authorization.replace("Bearer ", "");

    /** Internal users can switch partners in multiple tabs */
    const bearerPartner = jwtDecode(bearer).partner;
    const tokenPartner = jwtDecode(getToken()).partner;
    /** Internal users */
    if (bearerPartner !== tokenPartner) {
      window.alert(`Multiple tabs with different Partners, close this window.`);
      return Promise.reject("Partner has changed");
    }

    if (bearer !== getToken()) {
      console.info("Replacing Token");
      fillHeaderAuth();
    }
  }
  return Promise.resolve(config);
});
Vue.http.interceptors.response.use(undefined, async error => {
  let originalRequest = error.config;
  if (originalRequest.url !== originalRequest.baseURL + "auth/refresh") {
    if (
      error.response.status === 401 &&
      !originalRequest._retry &&
      error.response.data.message === "token_expired"
    ) {
      originalRequest._retry = true;

      try {
        let refresh = await Vue.http.get("auth/refresh");
        store.dispatch("fillAuth", {
          user: refresh.data.user,
          token: refresh.data.token
        });
        originalRequest.headers.Authorization = Vue.http.defaults.headers.common.Authorization;

        return Vue.http(originalRequest);
      } catch (err) {
        originalRequest._retry = true;
        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
});

Vue.component("svg-icon", SVGIcon);

Vue.use(Toasted, {
  duration: 8000,
  action: [
    {
      text: "Close",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      }
    }
  ]
});

Vue.component("downloadExcel", JsonExcel);
// Vue.use(VueDragDrop);
